export default __webpack_public_path__ + "static/we-believe-red-icons-with-circle-191a324396462964a026fa45111c280f.svg";